import { SectionGridSize } from "../helpers/enums";

export const TitleLayoutPresets = Object.freeze({
  CENTERED: "centered",
  LEFT_HERO: "left-hero",
  BOTTOM_SPLIT: "bottom-split",
  centered: "centered",
  "left-hero": "left-hero",
  "bottom-split": "bottom-split",
});

const alignTextBlocks = (blocks, textAlign) => {
  if (!Array.isArray(blocks)) return blocks;
  return blocks.map((b) => {
    if (b.type !== "text" || !b.text) return { ...b };
    try {
      const parsed = JSON.parse(b.text);
      if (parsed && Array.isArray(parsed.blocks)) {
        const updatedBlocks = parsed.blocks.map((pb) => ({
          ...pb,
          data: { ...(pb.data || {}), "text-align": textAlign },
        }));
        return {
          ...b,
          text: JSON.stringify({ ...parsed, blocks: updatedBlocks }),
        };
      }
    } catch {
      // not JSON, keep as is
    }
    return { ...b };
  });
};

export const applyTitlePreset = (section, presetId) => {
  if (!section) return section;
  const containers = Array.isArray(section.containers)
    ? [...section.containers]
    : [];

  switch (presetId) {
    case "centered":
    case TitleLayoutPresets.CENTERED: {
      const updatedContainers = containers.map((c, i) =>
        i === 0
          ? {
              ...c,
              horizontalAlign: "center",
              startColumn: 4,
              endColumn: 7,
              blocks: alignTextBlocks(c.blocks, "center"),
            }
          : { ...c }
      );
      return {
        ...section,
        gridSize: SectionGridSize.NINE_COLUMNS,
        verticalAlign: "center",
        containers: updatedContainers,
      };
    }
    case "left-hero":
    case TitleLayoutPresets.LEFT_HERO: {
      const updatedContainers = containers.map((c, i) =>
        i === 0
          ? {
              ...c,
              horizontalAlign: "left",
              startColumn: 2,
              endColumn: 7,
              blocks: alignTextBlocks(c.blocks, "left"),
            }
          : { ...c }
      );
      return {
        ...section,
        gridSize: SectionGridSize.NINE_COLUMNS,
        verticalAlign: "center",
        containers: updatedContainers,
      };
    }
    case "bottom-split":
    case TitleLayoutPresets.BOTTOM_SPLIT: {
      const updatedContainers = containers.map((c, i) =>
        i === 0
          ? {
              ...c,
              horizontalAlign: "left",
              startColumn: 2,
              endColumn: 12,
              blocks: alignTextBlocks(c.blocks, "left"),
            }
          : { ...c }
      );
      return {
        ...section,
        verticalAlign: "bottom",
        gridSize: SectionGridSize.TWELVE_COLUMNS,
        containers: updatedContainers,
      };
    }
    default:
      return {
        ...section,
        containers: containers.map((c) => ({ ...c })),
      };
  }
};

export const applyBodyTwoColumnPreset = (section) => {
  if (!section) return section;
  const existingContainers = Array.isArray(section.containers)
    ? section.containers
    : [];

  const firstContainer = existingContainers[0]
    ? { ...existingContainers[0], startColumn: 2, endColumn: 6 }
    : {
        startColumn: 2,
        endColumn: 6,
        horizontalAlign: "left",
        blocks: [{ type: "text", text: "" }],
      };

  const secondContainer = existingContainers[1]
    ? { ...existingContainers[1], startColumn: 7, endColumn: 11 }
    : {
        startColumn: 7,
        endColumn: 11,
        horizontalAlign: "left",
        blocks: [{ type: "text", placeholder: "Klikk her for å skrive" }],
      };

  return {
    ...section,
    gridSize: SectionGridSize.TWELVE_COLUMNS,
    containers: [firstContainer, secondContainer],
  };
};

export const applyBodyOneColumnPreset = (section) => {
  if (!section) return section;
  const existingContainers = Array.isArray(section.containers)
    ? section.containers
    : [];

  const firstContainer = existingContainers[0]
    ? { ...existingContainers[0], startColumn: 5, endColumn: 6 }
    : {
        startColumn: 5,
        endColumn: 6,
        horizontalAlign: "left",
        blocks: [{ type: "text", text: "" }],
      };

  return {
    ...section,
    gridSize: SectionGridSize.NINE_COLUMNS,
    containers: [firstContainer],
  };
};

export const StickyCardPlacementPresets = Object.freeze({
  LEFT: "left",
  CENTER: "center",
  RIGHT: "right",
  left: "left",
  center: "center",
  right: "right",
});

export const applyStickyCardPlacement = (container, placement, gridSize) => {
  if (!container) return container;
  const is12Col = gridSize === SectionGridSize.TWELVE_COLUMNS;

  let columns = { startColumn: container.startColumn, endColumn: container.endColumn };

  switch (placement) {
    case "left":
    case StickyCardPlacementPresets.LEFT:
      columns = is12Col
        ? { startColumn: 2, endColumn: 6 }
        : { startColumn: 2, endColumn: 5 };
      break;
    case "center":
    case StickyCardPlacementPresets.CENTER:
      columns = is12Col
        ? { startColumn: 5, endColumn: 9 }
        : { startColumn: 5, endColumn: 6 };
      break;
    case "right":
    case StickyCardPlacementPresets.RIGHT:
      columns = is12Col
        ? { startColumn: 8, endColumn: 12 }
        : { startColumn: 6, endColumn: 9 };
      break;
    default:
      break;
  }

  return {
    ...container,
    ...columns,
  };
};
